import { Component, computed, effect, ViewChild,} from "@angular/core";
import {
  MatDrawerMode,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatToolbarModule } from "@angular/material/toolbar";
import { RouterModule, Router } from "@angular/router";
import { SidenavComponent } from "../../../../theme/components/sidenav/sidenav.component";
import { MenuService } from "../../../../theme/services/menu.service";
import { UserMenuComponent } from "../../../../shared/components/user-menu/user-menu.component";
import { CommonModule } from "@angular/common";
import { BreakPointService } from "../../../../shared/services/break-point/break-point.service";
import { AuthenticationService } from "../../../../shared/services/authentication/authentication.service";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule} from '@angular/material/select';
import { ConfigService } from "../../../../shared/services/config/config.service";
import { MatButtonModule } from '@angular/material/button';
import { MatSelect } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DashboardService } from "../../../dashboard/services/dashboard.service";
import { UserProfile } from "../../../../models/profile.model";
import { DownloadStatusComponent } from "../download-status/download-status.component";
import { EnvironmentIndicatorComponent } from "../../../../shared/components/environment-indicator/environment-indicator.component";

@Component({
  selector: "app-uss-toolbox-wrapper",
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    MatToolbarModule,
    SidenavComponent,
    UserMenuComponent,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatButtonModule,
    MatTooltipModule,
    DownloadStatusComponent,
    EnvironmentIndicatorComponent
  ],
  templateUrl: "./uss-toolbox-wrapper.component.html",
  styleUrl: "./uss-toolbox-wrapper.component.scss",
})
export class UssToolboxWrapperComponent {
  @ViewChild('roleSelect') roleSelect!: MatSelect;
  drawerModeType: MatDrawerMode = "side";
  menuCollapsed: boolean = false;
  breakpoints!: string;
  user = computed(() => this.authenticationService.userSignal());
  RBACTestEnabled : boolean = false;
  isDrawerOpened = true;

  roleFormControl = new FormControl<string[]>([]);
  rolesList: string[] = [];

  constructor(
    public menuService: MenuService,
    public breakPointService: BreakPointService,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private dashboardService: DashboardService,
    private router: Router
  ) {
    this.breakPointService.widthSignal.set(window.innerWidth);
    this.breakPointService.getBreakpoint();
    this.RBACTestEnabled = Boolean(this.configService.getConfigProperty('RBAC_TEST_ENABLED'));
    effect(() => {
      this.menuCollapsed = menuService.isMenuCollapsed();
    });
    effect(() => {
      this.breakpoints = this.breakPointService.breakPointSignal() as string;
      this.setResponsiveDrawer();
    });
    effect(()=>{
      const role = this.authenticationService.getUserRoles();
      this.rolesList = this.authenticationService.RBACTestDropDownSignal();
      this.roleFormControl.setValue(role);
    });
    effect(() => {
      this.isDrawerOpened = this.menuService.drawerOpened();
    });
  }


  toggleSidenav(isCollapsed: boolean) {
    this.menuService.updateMenuCollapsed(isCollapsed);
  }

  ngAfterViewInit() {
    this.setResponsiveDrawer();
  }

  closeDrawer() { this.menuService.closeDrawer(); }
  openDrawer() { this.menuService.openDrawer(); }
  toggleDrawer() { this.menuService.toggleDrawer(); }

  setResponsiveDrawer() {
    if (this.breakpoints == "sm" || this.breakpoints == "xs") {
      this.drawerModeType = "over";
      this.closeDrawer();
    } else {
      this.drawerModeType = "side";
      this.openDrawer();
    }
  }

  onApplyClick() {
    const rolesString = this.roleFormControl.value?.join(',') || '';
    const userProfile = {
      ...JSON.parse(localStorage.getItem("profile") as string),
      roles: rolesString
    };
    const { isUpdated, ...profileWithoutUpdateFlag } = userProfile;

    this.dashboardService.updateUserRoles(profileWithoutUpdateFlag).subscribe((res: UserProfile) => {
      this.authenticationService.setUserRoles(this.roleFormControl.value || []);
      const profileWithUpdateFlag = { ...res, isUpdated: true };
      localStorage.setItem("profile", JSON.stringify(profileWithUpdateFlag));
      this.roleSelect.close();
    });
    this.router.navigate(['/dashboard']);
  }

  onClick(){
    if(!this.authenticationService.isAuthenticated()){
      window.location.href = "/";
    }
  }

}
